import { render, staticRenderFns } from "./ResourceCalendarHorizontal.vue?vue&type=template&id=313de050"
import script from "./ResourceCalendarHorizontal.vue?vue&type=script&lang=js"
export * from "./ResourceCalendarHorizontal.vue?vue&type=script&lang=js"
import style0 from "./ResourceCalendarHorizontal.vue?vue&type=style&index=0&id=313de050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports